import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/dao/page.tsx");
